export const isRetinaDisplay = () => {
  if (window.matchMedia) {
    const media = `only screen and (min--moz-device-pixel-ratio: 1.3),
                     only screen and (-o-min-device-pixel-ratio: 2.6/2),
                     only screen and (-webkit-min-device-pixel-ratio: 1.3),
                     only screen  and (min-device-pixel-ratio: 1.3),
                     only screen and (min-resolution: 1.3dppx)`

    const mq = window.matchMedia(media)
    return (mq && mq.matches) || window.devicePixelRatio > 1
  }

  return null // can't detect retina
}



// WEBPACK FOOTER //
// ./shared/util/index.js